import React, { useState } from "react";
import { CompanyAvatar } from "../../../../components/render-file/CompanyAvatar";
import userNoImage from "../../../../assets/images/user-noimage.png";
import { Company, Customer } from "../../../../core";
export interface CompanyWithUser {
  title: string | undefined;
  items: Customer[];
  companyDetails: Company
}
const MergeUserField: React.FunctionComponent<{
  name: string;
  onUpdate: (numbers: Customer[]) => void;
  data: (CompanyWithUser | undefined)[];
  showType: boolean;
}> = (props) => {
  const [values, setValues] = useState<Customer[]>([]);

  const onSelect = (customer: Customer) => {
    setValues((prevvalues: Customer[]) => {
      // Check if the selected value is already in the list
      const phoneExists = prevvalues.some((customerData) => customerData._id === customer._id);

      if (phoneExists) {
        // Remove the value if it's already present
        return prevvalues.filter((phone) => phone._id !== customer._id);
      } else {
        // Add the value if it's not present
        return [...prevvalues, customer];
      }
    });
  };

  React.useEffect(() => {
    props?.onUpdate(values);
  }, [values]);

  return (
    <>
      {props?.data?.map(
          (company, companyIndex) =>
              <div key={companyIndex} className="contact mb-2">
                <div className={`row ${company?.items?.length ? 'border-bottom' : ''} border-black pb-3`}>
                  <div className="col-12">
                    <h5 className="pb-3 pt-2">{company?.title}</h5>
                    {company?.items.map((people, index) => {
                        const checkboxId = `checkbox_${props?.name}_${companyIndex}_${index}`;
                        return (
                          <div key={index} className="border border-black d-flex mb-2 p-3 rounded">
                            <figure className="mb-0" style={{
                              height: '50px',
                              width: '50px',
                            }}>
                               <CompanyAvatar
                                  className="img-thumbnail  rounded-circle w-100 h-100"
                                  defaultImage={userNoImage}
                                ></CompanyAvatar>
                            </figure>

                            <figcaption className="d-flex flex-column justify-content-center ml-3 pr-2">
                              <h6 className="font-normal font-weight-semibold mb-1">
                                {people.fullName}
                              </h6>
                              <p className="font-sm mb-0">
                                {people.primaryPhone}
                                <span>
                                  {" "}
                                  {people.primaryEmail}
                                </span>
                              </p>
                            </figcaption>

                            <input
                              type="checkbox"
                              id={checkboxId}
                              name={props.name + "checkbox"}
                              onChange={() =>
                                onSelect(people)
                              }
                              checked={values.some(
                                (value) => value._id === people._id
                              )}
                            />
                            <label
                              className="ml-auto pl-3"
                              htmlFor={checkboxId}
                            >
                              &nbsp;
                            </label>
                          </div>
                        );
                      })}
                  </div>
                </div>
              </div>
        )}
    </>
  );
};

export default MergeUserField;
